// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3GpA_","emails":"CreateEditClinics_emails__3fsJS","emailTagLabel":"CreateEditClinics_emailTagLabel__3SWvL"};